































import CommonBase from "../CommonBase";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "./Api";
import {Terminal, TerminalLocationWithStats} from "../../modules/models";

@Component
export default class TerminalChangelocation extends CommonBase {
    @Inject()
    api!: Api;

    @Prop()
    terminal!: Terminal;

    @Prop()
    currentLocid!: number;

    @Prop()
    value!: boolean;

    loadingLocs = false;
    locswithstats: TerminalLocationWithStats[] = [];
    showInactive = false;

    get locs() {
        return this.locswithstats.map((lws) => lws.termloc).filter((l) => l.id != this.currentLocid && (this.showInactive || l.shutdownTime === null));
    }

    async loadLocs() {
        this.loadingLocs = true;
        try {
            this.locswithstats = await this.api.fetchLocations(this.terminal.companyOrgNum);
        } catch(err) {
            this.emitError(err);
        } finally {
            this.loadingLocs = false;
        }
    }
    async changeLocation(toLocid: number) {
        try {
            await this.api.terminalLocationSet(this.terminal.guid, toLocid);
            this.$emit("at-terminal-location-changed", toLocid);
            this.close();
        } catch(err) {
            this.emitError(err);
        }
    }

    get show() {
        return this.value;
    }
    set show(v: boolean) {
        this.$emit("input", v);
    }
    close() {
        this.show = false;
    }

    // load the locations when the dialog is shown
    @Watch("value")
    onValueChanged(doShow: boolean) {
        if(doShow) {
            this.loadLocs();
        }
    }
}
